import React from 'react';

interface SubCategoryCarouselProps {
  children: React.ReactNode;
}

function SubCategoryCarousel({ children }: SubCategoryCarouselProps) {
  return (
    <div className="sub-carousel-track">
      {children}
    </div>
  );
}

export default SubCategoryCarousel;